import { Dashboard } from '@components/common/Dashboard';
import { PageLayout } from '@components/common/PageLayout';
import { DashboardBackButton } from '@components/utils';
import { SECTION_NAMES } from '@constants/sectionNames';
import { ButtonClean, HeadContent, Loading } from '@fourthwall/components';
import { routing } from '@utils/routing';
import React from 'react';
import { ConnectBar } from '../../components/ConnectBar/ConnectBar';
import { useEchobrain } from './hooks/useEchobrain';
export const AppsEchobrain = () => {
    const { connectBar, isLoading } = useEchobrain();
    if (!connectBar) {
        return React.createElement(Loading, { isLoading: isLoading });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Echobrain" }),
        React.createElement(PageLayout, { size: "tiny" },
            React.createElement(Dashboard.Section, { name: "Echobrain", topContent: React.createElement(DashboardBackButton, { label: SECTION_NAMES.apps, to: routing.apps.self }), bottomContent: React.createElement("p", null,
                    "Get verified reviews for your products, showcase them in awesome ways, and include custom forms in your Fourthwall shop.",
                    React.createElement(ButtonClean, { label: "Learn More", href: routing.external.echobrain.learnMore, target: "_blank" })) },
                React.createElement(Loading, { isLoading: isLoading },
                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 16 } },
                        React.createElement(ConnectBar, { ...connectBar })))))));
};
